import {DeviceProvide} from "@hybird/core/device/provide";
import {
  MqttDeviceProtocol,
  MqttDeviceProtocolBeginSeal,
  MqttDeviceProtocolOperation
} from "@hybird/device/protocol/mqtt";
import {BleDeviceProtocol, BleDeviceProtocolBeginSeal, BleDeviceProtocolOperation} from "@hybird/device/protocol/ble";
import {CompositeDeviceProtocol, DeviceEvent} from "@hybird/core/device/protocol";
import {DeviceType} from "@hybird/device/config";
import {WebError} from "@hybird/core/error";
import {deviceError} from "@hybird/device/deviceError";
import service from "@hybird/core/request";
import url from "@hybird/device/request";

class AplusDeviceProvide extends DeviceProvide {

  _deviceProtocols = {
    2: AplusMqttDeviceProtocol,
    1: AplusBleDeviceProtocol,
    3: AplusCompositeDeviceProtocol
  };

  constructor(deviceConnectProvide) {
    super(deviceConnectProvide);
  }

  isSupport(deviceInfo) {
    return DeviceType.aplus === deviceInfo.modelType;
  }
}

class AplusCompositeDeviceProtocol extends CompositeDeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption) {
    super(deviceProvide, deviceInfo, deviceProtocolOption);
  }

  get connectPromiseType() {
    return 2;
  }

  get deviceProtocols() {
    return {
      2: AplusMqttDeviceProtocol, 1: AplusBleDeviceProtocol
    };
  }
}

class AplusMqttDeviceProtocol extends MqttDeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption) {
    super(deviceProvide, deviceInfo, deviceProtocolOption);
  }

  _createDeviceProtocolBeginSeal(option) {
    return new AplusMqttDeviceProtocolBeginSeal(this.deviceInfo, this, option);
  }

  _createDeviceProtocolOperation() {
    return new AplusMqttDeviceProtocolOperation(this.deviceInfo, this);
  }
}

class AplusMqttDeviceProtocolBeginSeal extends MqttDeviceProtocolBeginSeal {
  constructor(deviceInfo, deviceProtocol, option) {
    super(deviceInfo, deviceProtocol, option);
  }
}

class AplusMqttDeviceProtocolOperation extends MqttDeviceProtocolOperation {
  constructor(deviceInfo, deviceProtocol) {
    super(deviceInfo, deviceProtocol);
  }

  async _wifiSetting({type, save = 1, ssid, password, success, complete, message, fail, timeout = 120}) {
    let fn;
    return new Promise(resolve => {
      this.send.service("network_configuration", {
        type, save, name: ssid, password,
      }, {
        success, complete, message, fail, timeout, retry: false
      }).then(data => {
        resolve(data.params);
        return data.params;
      });

      const fn = async () => {
        setTimeout(async () => {
          await this.deviceProtocol.connect();
          const operation = await this.deviceProtocol.operation();

          await operation.wifiList({
            onWifi: (data) => {
              for (const i in data) {
                const wifi = data[i];

                if (wifi.ssid === ssid) {
                  if (wifi.link === 1) {
                    service.post(url.operationLog, {
                      number: this.deviceInfo.number,
                      logType: 3
                    });

                    resolve({
                      status: 1,
                      message: ""
                    });
                  } else {
                    resolve({
                      status: 3,
                      message: "连接失败"
                    });
                  }
                  return;
                }
              }

              resolve({
                status: 3,
                message: "连接失败"
              });
            }
          })
        }, 2000);
      }

      this.deviceProtocol.once(DeviceEvent.ONLINE, fn)
    }).finally(() => {
      if (fn) {
        this.deviceProtocol.removeListener(DeviceEvent.ONLINE, fn)
      }
    })
  }

  async _wifiList({onWifi, success, complete, message, fail, timeout = 30}) {
    if (!this.send.property || this.send.property.network === 2) {
      throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT_CHANGE, {
        data: {
          curr: 2, change: 1
        }
      })
    }

    const wifi = [];
    const topic = {};
    this.send.service("wifi_list", {}, {
      success, complete, message, fail, timeout
    }).then(params => {
      const wifi = [];

      for (const i in params.data) {
        const data = params.data[i];
        data.link = data.currlink;

        if (!wifi.find(w => w.ssid === data.ssid)) {
          wifi.push(data);
          onWifi?.call(this, wifi);
        }
      }

      return params;
    }).catch(e => {
      console.log(e);
    })

    return {
      setting: ({type, save = 1, ssid, password, success, complete, message, fail, timeout}) => {
        this.send.unsubscribe(topic);
        return this.wifiSetting({
          type,
          save,
          ssid,
          password,
          success,
          complete,
          message,
          fail,
          timeout
        });
      }, cancel: () => {
        return this.send.unsubscribe(topic);
      }, onWifi: true
    };
  }
}

class AplusBleDeviceProtocol extends BleDeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption) {
    super(deviceProvide, deviceInfo, deviceProtocolOption);
  }

  _createDeviceProtocolBeginSeal(option) {
    return new AplusBleDeviceProtocolBeginSeal(this.deviceInfo, this, option);
  }

  _createDeviceProtocolOperation() {
    return new AplusBleDeviceProtocolOperation(this.deviceInfo, this);
  }
}

class AplusBleDeviceProtocolBeginSeal extends BleDeviceProtocolBeginSeal {
  constructor(deviceInfo, deviceProtocol, option) {
    super(deviceInfo, deviceProtocol, option);
  }
}

class AplusBleDeviceProtocolOperation extends BleDeviceProtocolOperation {
  constructor(deviceInfo, deviceProtocol) {
    super(deviceInfo, deviceProtocol);
  }

  async fingerprintOperation({type, staffId, success, complete, message, fail, timeout} = {}) {
    throw WebError.code(deviceError.PROTOCOL_NOT_SUPPORT);
  }
}

export {
  AplusDeviceProvide,
  AplusMqttDeviceProtocol,
  AplusMqttDeviceProtocolBeginSeal,
  AplusMqttDeviceProtocolOperation,
  AplusBleDeviceProtocol,
  AplusBleDeviceProtocolBeginSeal,
  AplusBleDeviceProtocolOperation
};